module.exports = __webpack_public_path__ + "static/media/noun_team_2339682.a8bafa63.svg";